import el from "@cypherpotato/el";
import { joinObjects, truncateArray } from "../util";
import { Button, ButtonRow } from './button';
import { Icon } from "./icon";

export function Table(...children) {
    const { pagination } = joinObjects(...children);
    const table = el("table.app-table", children, {
        $functions: {
            refreshPagination() {
                if (!pagination?.perPage)
                    return;
                
                const perPage = pagination.perPage;
                const tbody = this.querySelector("tbody:not(.live)");
                if (!tbody) {
                    return;
                }

                const currentPage = el.state.create(0);

                const rows = Array.from(tbody.children);
                const totalRows = rows.length;
                const totalPages = Math.ceil(totalRows / perPage);

                function updateRenderedRows() {
                    const startIndex = (currentPage.value) * perPage;
                    const endIndex = startIndex + perPage;

                    rows.forEach((row, index) => {
                        if (index >= startIndex && index < endIndex) {
                            row.style.display = "";
                        } else {
                            row.style.display = "none";
                        }
                    });
                }

                const footer = el.state.listening([currentPage], () =>
                    el("tfoot",
                        TableRow(
                            TableCell({ colspan: 99, style: { textAlign: "right" } },
                                ButtonRow(
                                    Button(Icon("arrow-left-line"), {
                                        onClick() {
                                            currentPage.value = Math.max(currentPage.value - 1, 0);
                                            updateRenderedRows();
                                        },
                                        disabled: currentPage.value <= 0
                                    }),
                                    truncateArray(Array.from(Array(totalPages).keys()), 6).map(i =>
                                        Button(typeof i === 'number' ? i + 1 : i, {
                                            onClick() {
                                                if (typeof i === 'number') {
                                                    currentPage.value = i;
                                                    updateRenderedRows();
                                                }

                                            },
                                            disabled: currentPage.value === i || typeof i !== 'number'
                                        })
                                    ),
                                    Button(Icon("arrow-right-line"), {
                                        onClick() {
                                            currentPage.value = Math.min(currentPage.value + 1, totalPages);
                                            updateRenderedRows();
                                        },
                                        disabled: currentPage.value >= totalPages - 1
                                    })
                                )
                            )
                        )
                    )
                )

                updateRenderedRows();
                const currentFooter = table.querySelector("tfoot");
                if (currentFooter) {
                    currentFooter.replaceWith(footer);
                } else {
                    table.appendChild(footer);
                }
            }
        },
        mount() {
            this.refreshPagination();
        }
    });

    return table;
}

export function TableHeader(...children) {
    return el("thead",
        ...children
    );
}

export function TableHeaderCell(...children) {
    return el("th",
        ...children
    )
}

export function TableHeaderActionCell(...children) {
    return el("th.action-cell",
        ...children
    )
}

export function TableBody(...children) {
    return el("tbody",
        ...children
    )
}

export function TableRow(...children) {
    return el("tr",
        ...children
    )
}

export function TableHorizontalBar() {
    return el("tr.horizontal-bar",
        el("td", { colspan: 999 })
    )
}

export function TableSeparator(...children) {
    return el("tr",
        el("td.separator",
            ...children
        )
    )
}

export function TableCell(...children) {
    return el("td",
        ...children
    )
}

export function TableActionCell(...children) {
    return el("td.action-cell",
        ...children
    )
}

export function DefaultRow(...children) {
    return el("tr",
        el("td.table-default", { colspan: 999 }, ...children)
    )
}